import { Injectable } from '@angular/core';

@Injectable()
export class ClaimsService {
  private ssoId: string;
  private email: string;
  private name: string;
  private preferredName: string;
  private firstName: string;
  private lastName: string;

  constructor() { }

  setSsoId(val) {
    this.ssoId = val;
  }

  getSsoId() {
    return this.ssoId;
  }

  setEmail(val) {
    this.email = val;
  }

  getEmail() {
    return this.email;
  }

  setName(val) {
    this.name = val;
  }

  getName() {
    return this.name;
  }

  setPreferredName(val) {
    this.preferredName = val;
  }

  getPreferredName() {
    return this.preferredName;
  }
  setFirstName(val) {
    this.firstName = val;
  }

  getFirstName() {
    return this.firstName;
  }

  setLastName(val) {
    this.lastName = val;
  }

  getLastName() {
    return this.lastName;
  }
}
